import { ReactNode } from 'react';
import { cx } from '@libs/classnames';
import styles from './Leaders.module.css';
import { LandingSectionTitle } from '@features/landing/shared/ui/components/LandingSectionTitle';
import { LeaderboardClock } from '@features/landing/grandprix/typings';

const CLOCK_TITLES: Record<LeaderboardClock, string> = {
  blitz: 'Блиц',
  rapid: 'Рапид',
};

type Props = {
  preset?: 'landing' | 'club';
  size?: 'small' | 'medium' | 'large';
  clock: LeaderboardClock;
  tabs: ReactNode;
  largeBlitzLists: ReactNode;
  largeRapidLists: ReactNode;
  mediumLists: ReactNode;
  smallLists: ReactNode;
};

export function Leaders({
  preset = 'landing',
  size = 'large',
  clock,
  tabs,
  largeBlitzLists,
  largeRapidLists,
  mediumLists,
  smallLists,
}: Props) {
  return (
    <div
      className={cx(
        styles.root,
        styles[`preset_${preset}`],
        styles[`size_${size}`],
      )}
    >
      <LandingSectionTitle>
        <span className={styles.title}>Лидеры Гран-при РШШ</span>
        <span className={styles.titleSmall}>
          Лидеры
          <br />
          Гран-при РШШ
        </span>
      </LandingSectionTitle>

      <div className={styles.tabs}>{tabs}</div>

      <div className={styles.leaderboard}>
        {size === 'large' && (
          <>
            <h3 className={cx(styles.leaderboardTitle, styles.left)}>
              {CLOCK_TITLES['blitz']}
            </h3>
            {largeBlitzLists}

            <h3 className={cx(styles.leaderboardTitle, styles.right)}>
              {CLOCK_TITLES['rapid']}
            </h3>
            {largeRapidLists}
          </>
        )}

        {size === 'medium' && (
          <>
            <h3 className={styles.leaderboardTitle}>{CLOCK_TITLES[clock]}</h3>
            {mediumLists}
          </>
        )}

        {size === 'small' && smallLists}
      </div>
    </div>
  );
}
